import React from 'react'
import styled from 'styled-components'

function Checkout() {
    return (
        <Container>
            <h1>This is a Clone</h1>
        </Container>
    )
}

export default Checkout


const Container=styled.div`
h1{
    padding-top: 100px;
}


`